/**
 * AbstractFormFragment — base class for all form fragment components.
 */
export class AbstractFormFragment {
  protected node: HTMLElement;
  private delayTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(el: HTMLElement) {
    this.node = el;
  }

  initializeNode(): this {
    return this;
  }

  isRequired(): boolean {
    return this.node.getAttribute('data-form-fragment-required')?.toLowerCase() === 'true';
  }

  isValid(): boolean {
    return !this.isRequired() || this.hasValue();
  }

  getLabel(): string {
    return this.node.querySelector('label')?.textContent?.trim() ?? '';
  }

  hasValue(): boolean {
    return false;
  }

  attachChangeListener(_callback: () => void): this {
    return this;
  }

  triggerDelayed(callback: () => void): void {
    if (this.delayTimeout !== null) clearTimeout(this.delayTimeout);
    this.delayTimeout = setTimeout(callback, 200);
  }

  blurOnMouseRealMouseClick(): void {
    this.node.addEventListener('click', (event: MouseEvent) => {
      if (event.clientX || event.clientY) {
        // Only for real mouse clicks — tab keypress also fires click events
        (event.target as HTMLElement).blur?.();
      }
    });
  }

  showErrorMsgIfInvalid(): void {
    const indicator = this.getErrorIndicatorNode();
    indicator?.classList.toggle('error', !this.isValid());
    this.node.querySelector('.error-message')?.classList.toggle('hidden', this.isValid());
  }

  getErrorIndicatorNode(): HTMLElement | null {
    return null;
  }

  static getCssClassName(): string {
    return '';
  }
}

export default AbstractFormFragment;
